import { render, staticRenderFns } from "./TemplateTab.vue?vue&type=template&id=7534d50c"
import script from "./TemplateTab.vue?vue&type=script&lang=js"
export * from "./TemplateTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports